import { useState, useEffect, useCallback } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  const handleScroll = useCallback(() => {
    setScrolled(window.scrollY > 60);
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    if (mobileOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => { document.body.style.overflow = ''; };
  }, [mobileOpen]);

  const isHome = location.pathname === '/';

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
            <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
              <i className="fa-solid fa-magnet text-background-50 text-lg"></i>
            </div>
            <span className={`text-lg font-heading font-bold transition-colors ${
              scrolled || !isHome ? 'text-foreground-900' : 'text-background-50'
            }`}>
              磁力网站大全
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
                location.pathname === '/'
                  ? scrolled || !isHome ? 'bg-primary-100 text-primary-700' : 'bg-background-50/20 text-background-50'
                  : scrolled || !isHome ? 'text-foreground-700 hover:text-foreground-900 hover:bg-background-100' : 'text-background-50/80 hover:text-background-50 hover:bg-background-50/10'
              }`}
            >
              首页
            </Link>
            {categories.slice(0, 5).map(cat => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
                  location.pathname === `/category/${cat.slug}`
                    ? scrolled || !isHome ? 'bg-primary-100 text-primary-700' : 'bg-background-50/20 text-background-50'
                    : scrolled || !isHome ? 'text-foreground-700 hover:text-foreground-900 hover:bg-background-100' : 'text-background-50/80 hover:text-background-50 hover:bg-background-50/10'
                }`}
              >
                {cat.name}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/about"
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
                scrolled || !isHome ? 'text-foreground-600 hover:text-foreground-900 hover:bg-background-100' : 'text-background-50/80 hover:text-background-50'
              }`}
            >
              关于我们
            </Link>
            <Link
              to="/about"
              className="px-5 py-2 rounded-lg bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              推荐网站
            </Link>
          </div>

          <button
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg transition-colors ${
              scrolled || !isHome ? 'text-foreground-700 hover:bg-background-100' : 'text-background-50 hover:bg-background-50/10'
            }`}
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-4 space-y-1">
            <Link to="/" className="block px-4 py-3 rounded-lg text-foreground-700 hover:bg-background-100 font-medium text-sm">首页</Link>
            {categories.map(cat => (
              <Link key={cat.slug} to={`/category/${cat.slug}`} className="block px-4 py-3 rounded-lg text-foreground-700 hover:bg-background-100 font-medium text-sm">
                {cat.name}
              </Link>
            ))}
            <Link to="/about" className="block px-4 py-3 rounded-lg text-foreground-700 hover:bg-background-100 font-medium text-sm">关于我们</Link>
            <Link to="/about" className="block px-4 py-3 rounded-lg bg-primary-500 text-background-50 font-medium text-sm text-center mt-2">推荐网站</Link>
          </div>
        </div>
      )}
    </nav>
  );
}